var __rspack_ns_object = JSON.parse('{"Series is tracked":"السلسلة متتبعة","Series is untracked":"السلسلة غير متتبعة","Viewport":"منفذ العرض"}')